import API_URL from '../config';
import { getAuthHeaders } from '../utils/api';

export const getLeagueTiers = async () => {
  const response = await fetch(`${API_URL}/api/league/tiers`);
  if (!response.ok) {
    throw new Error('Failed to fetch league tiers');
  }
  return response.json();
};

export const getMyLeagueStatus = async () => {
  const response = await fetch(`${API_URL}/api/league/my-status`, {
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch league status');
  }
  return response.json();
};

export const getLeagueLeaderboard = async (tier = 'bronze') => {
  const response = await fetch(`${API_URL}/api/league/leaderboard?tier=${tier}`, {
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch league leaderboard');
  }
  return response.json();
};

export const joinLeague = async () => {
  const response = await fetch(`${API_URL}/api/league/join`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to join league');
  }
  return response.json();
};
